// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconStyle{
    fill : #CCCFD6 !important
}

.iconStyle:hover{
    fill: #3249D7 !important
}
`, "",{"version":3,"sources":["webpack://./src/modules/Resume/style.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI;AACJ","sourcesContent":[".iconStyle{\n    fill : #CCCFD6 !important\n}\n\n.iconStyle:hover{\n    fill: #3249D7 !important\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
